import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { formatDateRelative } from "simplydo/core/dates";
import { Button, ButtonLink } from "simplydo/react/ui/button";

import util from "utils/utils";

import RowComponent from "components/lib/RowComponent";

import type { HomeChallenge } from "./types";

type HomeChallengesProps = { challenges: HomeChallenge[] };

function HomeChallenges({ challenges }: HomeChallengesProps) {
  const { t } = useTranslation();

  if (!challenges || !challenges.length) return null;
  return (
    <RowComponent>
      <RowComponent.Fill>
        <RowComponent.Title>{t("generic.challenges")}</RowComponent.Title>
        <ButtonLink size="small" color="primary" to="/challenges/discover">
          {t("challenges.yours.sidebar.viewAll")}
        </ButtonLink>
      </RowComponent.Fill>
      {challenges.slice(0, 4).map((challenge, index) => (
        <RowComponent.Cell index={index} key={challenge._id} asChild>
          <Link to={`/challenges/${challenge._id}`}>
            <div
              style={{
                width: 50,
                height: 40,
                borderRadius: 3,
                flex: "0 0 50px",
                backgroundSize: "cover",
                backgroundPosition: "center center",
                backgroundImage: `url(${util.mixinCssUrlFallback(util.getImageUrl(challenge, ["coverImage", "bannerImage"], ["1280x200", "200x200"], util.challengeImage()))})`,
              }}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: 5,
                marginRight: 5,
                position: "relative",
                top: -1,
              }}
            >
              <RowComponent.Title wrapping style={{ color: "#5d5d5d" }} block>
                {challenge.name}
              </RowComponent.Title>
              <RowComponent.StatusArea>
                {challenge.stage === "closed" ? (
                  <>
                    <RowComponent.StatusLabel color="red" />{" "}
                    {t("generic.closed")}
                  </>
                ) : (
                  challenge.stage === "published" &&
                  (challenge.deadline ? (
                    <>
                      <RowComponent.StatusLabel color="blue" />
                      {t("generic.closes")}{" "}
                      {formatDateRelative(challenge.deadline, {
                        addSuffix: true,
                      })}
                    </>
                  ) : (
                    <>
                      <RowComponent.StatusLabel color="green" />
                      {t("generic.open")}
                    </>
                  ))
                )}
              </RowComponent.StatusArea>
            </div>
          </Link>
        </RowComponent.Cell>
      ))}
    </RowComponent>
  );
}

export default HomeChallenges;
